import { useNavigateWithSearch } from 'Modulor/hooks';
import { Routes } from 'Modulor/routes';
import { useLocation } from 'react-router-dom';
import type { CurrencyType } from 'store/slices/wallet';

import { FlowTypes } from '../../store/constants';

export const useCurrencyNavigation = () => {
  const navigate = useNavigateWithSearch();
  const location = useLocation();
  const currentPath = location.pathname;
  const flow =
    currentPath.includes('withdrawal') && !currentPath.includes('reject-withdrawal')
      ? FlowTypes.withdrawal
      : FlowTypes.deposit;

  const openCurrencySelector = (mode: CurrencyType) => {
    navigate(Routes.selectCurrency, {
      state: {
        background: location,
        mode,
        flow,
      },
    });
  };

  const openNetworkSelector = () => {
    navigate(Routes.selectNetwork, {
      state: {
        background: location,
        mode: 'network',
        flow,
      },
    });
  };

  return {
    openCurrencySelector,
    openNetworkSelector,
  };
};
